import { request } from "services/api/util";

class UserService {
  async getListUsers(param) {
    const config = {
      method: "get",
      url: `admin/adminUser`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async getDetailUsers(id) {
    const config = {
      method: "get",
      url: `admin/adminUser/${id}`,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async createUsers(body) {
    const config = {
      method: "post",
      url: `admin/adminUser`,
      data: body,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async updateUsers(id, body) {
    const config = {
      method: "put",
      url: `admin/adminUser/${id}`,
      data: body,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }

  async uploadExcel(file) {
    const config = {
      method: "post",
      url: `admin/importAdminUser`,
      data: file,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }

  async resetPasswordUser(data) {
    const config = {
      method: "post",
      url: `resetPassword`,
      data: data,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
}

export default new UserService();
